(() => {
  let modalSequence = 0;
  function syncIcons(root = document) {
    root.querySelectorAll('.cxk-image-quick-add').forEach(opener => {
      if (opener.dataset.cxkInitialized) return;
      const modal = opener.nextElementSibling;
      if (!modal || modal.tagName !== 'QUICK-ADD-MODAL') return;
      const id = 'QuickAdd-CXK-Unique-' + (++modalSequence);
      modal.id = id;
      opener.setAttribute('data-modal', '#' + id);
      const close = modal.querySelector('[id^="ModalClose-"]');
      const info = modal.querySelector('[id^="QuickAddInfo-"]');
      if (close) close.id = 'ModalClose-' + id;
      if (info) info.id = 'QuickAddInfo-' + id;
      opener.dataset.cxkInitialized = 'true';
    });
    const icon = document.querySelector('header .header__icon--cart svg');
    if (!icon) return;
    root.querySelectorAll('[data-cxk-bag-icon]').forEach(node => {
      if (node.dataset.synced) return;
      node.replaceChildren(icon.cloneNode(true)); node.dataset.synced='true';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>syncIcons());else syncIcons();
  new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1)syncIcons(node);}).observe(document.documentElement,{childList:true,subtree:true});
})();